<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.99875 3.1001C4.81208 3.1001 2.21875 5.69343 2.21875 8.8801C2.21875 12.0668 4.81208 14.6668 7.99875 14.6668C11.1854 14.6668 13.7787 12.0734 13.7787 8.88676C13.7787 5.7001 11.1854 3.1001 7.99875 3.1001ZM8.49875 8.66676C8.49875 8.9401 8.27208 9.16676 7.99875 9.16676C7.72542 9.16676 7.49875 8.9401 7.49875 8.66676V5.33343C7.49875 5.0601 7.72542 4.83343 7.99875 4.83343C8.27208 4.83343 8.49875 5.0601 8.49875 5.33343V8.66676Z"
    fill="#5B6673"
  />
  <path
    d="M9.92708 2.29992H6.07375C5.80708 2.29992 5.59375 2.08659 5.59375 1.81992C5.59375 1.55325 5.80708 1.33325 6.07375 1.33325H9.92708C10.1937 1.33325 10.4071 1.54659 10.4071 1.81325C10.4071 2.07992 10.1937 2.29992 9.92708 2.29992Z"
    fill="#5B6673"
  />
</svg>
